'use strict';
define([
    "dojo/_base/declare",
    "mw-filebrowser/actions/Action",
    "util",
    "dojo/i18n!nls/mldoStringResource"
], function (declare, Action, Util, MLDOStrings) {
  return declare(Action, {
    constructor: function (args) {
        args = args || {};
        var context = args.context;
        var makeActionAvailable = args.showAction || false;
        this.name =  "manageAction";
        this.label = MLDOStrings.contextMenuManageLabel;
        this.id = "mldoManageAction";
        this.enabled = makeActionAvailable;
        this.section = args.isSubMenu ? {
            id: "shareSub",
            enabled: false,
            isApplicableTo: function() { return false; },
            label: "sub1",
            parent: {
                id: "mldoShareAction",
                name: MLDOStrings.contextMenuShareLabel,
                label: MLDOStrings.contextMenuShareLabel,
                allowSubMenu: true,
                forceSubMenu: true
            }
        } : {
          id: "MISC",
          name: "MISC",
          allowSubMenu: false,
          forceSubMenu: false
        };
        this.supportsKeyBinding = false;
        this.isApplicableTo = function (path) {
          var selectedFileCount = context.getSelectedRowCount();
          let fileInfo;
          if (selectedFileCount > 1) {
            this.enabled = false;
            return false;
          } else if (selectedFileCount === 0) {
            fileInfo = context.getCurrentFolderInfo();
          } else {
            fileInfo = context.getSelectedItemFileInfos()[0];
          }
          
          const isInShare = fileInfo.isSharedFolder || !!fileInfo.sharedParentPath;
          const isOwner = fileInfo.accessType && fileInfo.accessType.toUpperCase() === "OWNER";
          const canWrite = fileInfo.filePermissions && fileInfo.filePermissions.canWrite;
          const invitationType = fileInfo.shareAttributes && fileInfo.shareAttributes.invitationType;
          const hasActiveLink = fileInfo.hasActiveLink;
          
          // Disable for MLD root and for files that are not shareable
          if (fileInfo.name === "/" || (!fileInfo.isDirectory && !fileInfo.shareable)) {
            this.enabled = false;
            return false;
          }
          if (isOwner) {
            if (!isInShare) {
              this.label = MLDOStrings.contextMenuInviteLabel;
              this.enabled = canWrite;
            } else {
              this.label = MLDOStrings.contextMenuManageLabel;
              this.enabled = true;
            }
            return this.enabled;
          }
        
          if (isInShare) { // Non-owner cases
            this.label = MLDOStrings.contextMenuViewMembersLabel;
            if (invitationType === "CREATED_FROM_OPEN" || hasActiveLink) { // Shared via link only (read-only)
              this.enabled = invitationType !== "CREATED_FROM_OPEN";
            } else {
              this.enabled = true;
            }
            return this.enabled;
          }
          this.enabled = false;
          return false;
        };
        this.callback = function (action) {
          var fileInfos = context.getSelectedItemFileInfos();
          var sortedFileInfos;
          var fileInfo;
          var path;
          if (fileInfos.length) {
            sortedFileInfos = Util.sortFileInfosByPath(fileInfos);
            fileInfo = fileInfos[0];
            path = context.getSelectedItemFullPath(fileInfo);
          } else {
            path = context.getSelectedItemFullPath();
            fileInfo = context.fileService.getCurrentFolderInfo();
            fileInfo.path = path;
          }

          // override if there is a linkPath value
          if ("linkPath" in fileInfo && fileInfo.linkPath && fileInfo.linkPath.length) {
            path = fileInfo.linkPath;
          }
          if (this.isApplicableTo()) {
            if (fileInfos.length <= 1 && fileInfo && path) {
              context.handleManageAction(path, fileInfo);
            }
          }
        };
    }
  });

});
